import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Reservations from './pages/reservations';
import Checkout from './pages/checkout';
import Waiver from './pages/waiver';
import WaiverComplete from './pages/waiver_complete';
import PhotoCaptureDemo from './components/PhotoCaptureDemo';
import { UserProvider } from './contexts/UserContext';

const App = () => {
  return (
    <UserProvider>
      <Router>
        <Routes>
          <Route 
            path="/" 
            element={<Reservations />} 
          />
          <Route 
            path="/reservation" 
            element={<Reservations />} 
          />
          <Route 
            path="/checkout" 
            element={<Checkout />} 
          />
          <Route 
            path="/waiver" 
            element={<Waiver />} 
          />          <Route 
            path="/waiver_complete" 
            element={<WaiverComplete />} 
          />
          <Route 
            path="/photo-demo" 
            element={<PhotoCaptureDemo />} 
          />
        </Routes>
      </Router>
    </UserProvider>
  );
};

export default App;
